import { setSearchURLWithParams } from './setSearchURLWithParams'

export const setWindowHistoryForSearch = (searchParams, baseUrl) => {
  const url = setSearchURLWithParams(searchParams, baseUrl)
  window.history.pushState({}, '', url)
}
